import {deleteCookie, getCookie, setCookie} from "./cookies";

export const AFFILIATE_CODE_COOKIE_NAME = "trendaro_affiliate_code";
export const AFFILIATE_CODE_PARAM = "ac";

const AFFILIATE_CODE_MAX_AGE_DAYS = 30;
const AFFILIATE_CODE_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

export const isValidAffiliateCode = (value: unknown): value is string =>
  typeof value === "string" && AFFILIATE_CODE_PATTERN.test(value);

export const readAffiliateCodeFromSearch = (
  search: string,
): string | undefined => {
  const params = new URLSearchParams(search);
  const value = params.get(AFFILIATE_CODE_PARAM);

  return isValidAffiliateCode(value) ? value : undefined;
};

/** Returns whether the code was actually persisted. */
export const storeAffiliateCode = (code: string): boolean => {
  if (!isValidAffiliateCode(code)) return false;

  return setCookie(AFFILIATE_CODE_COOKIE_NAME, code, {
    maxAgeDays: AFFILIATE_CODE_MAX_AGE_DAYS,
  });
};

export const getAffiliateCode = (): string | undefined => {
  // The cookie is re-validated on read, not just on write: anything able to
  // set it (a sibling subdomain, an extension, devtools) would otherwise put
  // an arbitrary string straight into a registration request body.
  const cookieValue = getCookie(AFFILIATE_CODE_COOKIE_NAME);
  if (isValidAffiliateCode(cookieValue)) return cookieValue;

  if (typeof window === "undefined") return undefined;

  return readAffiliateCodeFromSearch(window.location.search);
};

export const clearAffiliateCode = (): void => {
  deleteCookie(AFFILIATE_CODE_COOKIE_NAME);
};

export const buildAffiliateLink = (
  code: string,
  origin: string = window.location.origin,
): string => {
  const url = new URL("/", origin);
  url.searchParams.set(AFFILIATE_CODE_PARAM, code);

  return url.toString();
};
